{
  "promoter": {
    "agreement": {
      "title": "Sign your promoter agreement",
      "body": "Read the agreement below. You need to sign it before you can see your dashboard.",
      "program": "Program",
      "version": "Version",
      "fingerprint": "Document fingerprint (SHA-256), computed on this device",
      "fingerprintMismatch": "The file we received does not match the agreement on record. Reload the page before signing.",
      "pdfTitle": "Promoter agreement (PDF)",
      "pdfFallback": "Your browser cannot show the PDF here. Use Open PDF to read it.",
      "consentTitle": "Consent to electronic records and signatures",
      "consentVersion": "Consent text version {{version}}",
      "consentCheckbox": "I have read the text above and I agree to use electronic records and signatures.",
      "signatureTitle": "Your signature",
      "signatureHint": "Draw your signature with your finger, a pen or the mouse.",
      "signatureLabel": "Signature pad",
      "clear": "Clear",
      "sign": "Sign the agreement",
      "signing": "Signing…",
      "reload": "Reload the agreement"
    }
  }
}
